export function clock() {
  // Get all clock elements EXCEPT our custom clock blocks
  const clocks = document.querySelectorAll('.clock:not([data-custom-clock="true"])');

  if (!clocks.length) return;

  const updateClocks = () => {
    const date = new Date();

    const now = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    });

    const hour = parseInt(now.split(':')[0]);

    clocks.forEach((clock) => {
      const initialHour = clock.getAttribute('data-time') * 1;
      const hourSpan = clock.querySelector('.hour');
      const minuteSpan = clock.querySelector('.minute');
      const amPmSpan = clock.querySelector('.am-pm');

      const offset = (initialHour - hour) % 24;
      const h24 = (parseInt(now.split(':')[0]) + offset) % 24;
      const isAm = h24 < 12;
      const h12 = h24 % 12;

      hourSpan.textContent = h12 === 0 ? 12 : h12;
      minuteSpan.textContent = now.split(':')[1];
      amPmSpan.textContent = isAm ? 'am' : 'pm';
    });
  };

  updateClocks();

  setInterval(updateClocks, 1000);
}
